<template>
  <h4>Configuration</h4>
  <z-tabs v-model="currentTab" :tabs="tabs" @change="setTab" />
  <div class="custom-wrapper">
    <div v-if="currentTab === 'Channels'">
      <partner-channels />
    </div>
    <div v-if="currentTab === 'Apps'">
      <firm-apps />
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { authStore } from '@/stores/auth'
import { locationStore } from '@/stores/location'
import { lookupStore } from '@/stores/lookup'
import { appsStore } from '@/stores/apps'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import PartnerChannels from '@/components/configuration/channels/PartnerChannels.vue'
import FirmApps from '@/components/configuration/apps/FirmApps.vue'
export default {
  name: 'ConfigHost',
  components: {
    ZTabs,
    PartnerChannels,
    FirmApps
  },
  data() {
    return {
      currentTab: 'Channels'
    }
  },
  mounted() {
    this.setTab('Channels')
  },
  computed: {
    ...mapState(authStore, ['profile']),
    isAdmin() {
      let _is = false
      if (this.profile.roles[0] === 1 || this.profile.roles[0] === 2) {
        _is = true
      }
      return _is
    },
    tabs() {
      let _tabs = ['Channels', 'Apps']
      return _tabs
    }
  },
  methods: {
    ...mapActions(locationStore, ['getPartners']),
    ...mapActions(lookupStore, ['getLookups']),
    ...mapActions(appsStore, ['getApps', 'getFirmApps']),
    async setTab(value) {
      if (value === 'Channels') {
        await this.getPartners(1)
        await this.getLookups({
          keys: ['Channel'],
          firm: 1,
          refresh: false
        })
      } else if (value === 'Apps') {
        await this.getPartners(1)
        await this.getFirmApps(2)
        await this.getApps(null)
      }
      this.currentTab = value
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  padding: 15px;
  overflow-x: hidden;
  overflow-y: auto;
  max-height: 700px;
  height: 700px;
}
</style>
